import { defineStore, acceptHMRUpdate } from 'pinia'
import { until } from '~/assets/scripts/helpers'

export const useTranslationStore = defineStore('translation', {
  state: () => ({
    translations: {} as { [locale: string]: { [phrase: string]: string } },
    fetching_locales: [] as string[],
    fetched_locales: [] as string[],
    fetching_count: 0,
  }),
  getters: {
    translated: (state) => {
      return (locale: string, phrase: string) => (state.translations[locale] || {})[phrase]
    },
  },
  actions: {
    async getTranslation(locale: string, phrase: string): Promise<string> {
      if (!(locale in this.$state.translations)) {
        const ex = localStorage.getItem(`tr-${locale}`)
        const t = ex !== null ? JSON.parse(ex) : null
        if (t) {
          this.$patch((state) => {
            state.fetching_locales.push(locale)
            state.fetched_locales.push(locale)
            state.translations[locale] = t
          })
        } else {
          this.$state.translations[locale] = {}
        }
      }
      if (!(phrase in this.$state.translations[locale]!)) {
        this.$state.translations[locale]![phrase] = '_'
      }

      // if the block has not been fetched, fetch it.
      if (!this.$state.fetching_locales.includes(locale)) {
        this.$state.fetching_locales.push(locale)
        const resp: any = await $api('/api/translate/block/get', {
          params: { block: 'n3', to: locale },
        })
        this.$patch((state) => {
          state.fetched_locales.push(locale)
          state.translations[locale] = resp.translations
        })
        localStorage.setItem(`tr-${locale}`, JSON.stringify(resp.translations))
      } else if (!this.$state.fetched_locales.includes(locale)) {
        await until(() => this.$state.fetched_locales.includes(locale))
      }

      // if the block has been fetched and the phrase is not in it, do it individually
      if (this.$state.translations[locale]![phrase] === '_') {
        this.$state.translations[locale]![phrase] = ''
        this.$patch((state) => {
          state.translations[locale]![phrase] = ''
          state.fetching_count++
        })
        const resp: any = await $api('/api/translate', {
          method: 'POST',
          body: { phrase: phrase, block: 'n3', to: locale },
        }).catch((error) => {
          console.error(error)
        })
        this.$patch((state) => {
          state.translations[locale]![phrase] = resp.output
          state.fetching_count--
        })
        if (this.$state.fetching_count === 0) {
          localStorage.setItem(`tr-${locale}`, JSON.stringify(this.$state.translations[locale]))
        }
      }
      return this.$state.translations[locale]![phrase]!
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationStore, import.meta.hot))
}
